import { render, staticRenderFns } from "./ownCommitee.vue?vue&type=template&id=9f00a772&scoped=true&"
import script from "./ownCommitee.vue?vue&type=script&lang=js&"
export * from "./ownCommitee.vue?vue&type=script&lang=js&"
import style0 from "./ownCommitee.vue?vue&type=style&index=0&id=9f00a772&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f00a772",
  null
  
)

export default component.exports